import { QueryObserverResult, useQuery } from "@tanstack/react-query";
import {
  CurrentCompanyInfoDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CURRENT_COMPANY_INFO = "GET_CURRENT_COMPANY_INFO";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Viewer, UserRole.Auditor];

const getCurrentCompanyInfo = async (): Promise<CurrentCompanyInfoDto> => {
  const response = await companiesApi.companiesControllerGetCurrentCompanyInfo();

  return response.data;
};

export const useGetCurrentCompanyInfo = (
  user: UserProfileDto | null,
): {
  currentCompanyInfo?: CurrentCompanyInfoDto;
  currentCompanyInfoEnabled: boolean;
  isSuccessCurrentCompanyInfo: boolean;
  isFetchingCurrentCompanyInfo: boolean;
  isLoadingCurrentCompanyInfo: boolean;
  isPendingCurrentCompanyInfo: boolean;
  refetchCurrentCompanyInfo: () => Promise<
    QueryObserverResult<CurrentCompanyInfoDto, Error>
  >;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isFetching, isSuccess, isLoading, isPending, refetch } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
    queryFn: getCurrentCompanyInfo,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    currentCompanyInfo: data,
    currentCompanyInfoEnabled: enabled,
    isSuccessCurrentCompanyInfo: isSuccess,
    isFetchingCurrentCompanyInfo: isFetching,
    isLoadingCurrentCompanyInfo: isLoading,
    isPendingCurrentCompanyInfo: isPending,
    refetchCurrentCompanyInfo: refetch,
  };
};
